<template>
  <div>
    <quill-editor v-model="editorValue" :options="editorOptions" @blur="emitChange" @change="emitChange" />
    <small class="editor-help">
      Chọn ảnh rồi kéo nút ở góc để đổi kích thước; nhấp chuột phải vào bảng để chỉnh hàng và cột.
    </small>
  </div>
</template>

<script>
import TableHandler from "quill1.3.7-table-module";

export default {
  name: "RichTextEditor",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      editorValue: this.value,
      editorOptions: {
        theme: "snow",
        placeholder: "Nhập nội dung bài viết...",
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["blockquote", "code-block"],
            ["link", "image", TableHandler.toolName],
            ["clean"]
          ],
          [TableHandler.moduleName]: {
            fullWidth: true,
            customButton: "Chèn bảng"
          },
          imageResize: {
            modules: ["Resize", "DisplaySize", "Toolbar"]
          }
        }
      }
    };
  },
  watch: {
    value: function syncValue(nextValue) {
      if (nextValue !== this.editorValue) {
        this.editorValue = nextValue;
      }
    }
  },
  methods: {
    emitChange() {
      this.$emit("input", this.editorValue);
    }
  }
};
</script>

<style scoped>
.editor-help {
  display: block;
  margin-top: 8px;
  color: #5f7b9e;
  font-size: 12px;
}
</style>
